export const css = {
	root: '_2c-equ_q',
	studyplan_carousel: '_26995toJ',
	domain_carousels: '_1dVk0ROx',
	' _key': 'apic-theme/apic/explore-view/carousel-view'
};

export default css;
